"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validationFuncs = void 0;

/**
 * add zero to be length 8 digit for nif
 */
var prepareNifVal = function prepareNifVal(searchValue, selectedItem, setSearchValue, setTextVal) {
  var value = searchValue;
  var zeros = '';

  while (value.toString().length + zeros.length < selectedItem.maxLength) {
    zeros = zeros + '0';
  }

  setSearchValue(zeros + '' + value);
  setTextVal(zeros + '' + value);
  return zeros + '' + value;
};
/**
 * checkLastLetterValidation
 * check map of 8 digit % of 23 return with the same last letter or not
 */


var checkLastLetterValidator = function checkLastLetterValidator(val, validChars) {
  var letter = val.substr(-1).toUpperCase();
  var charIndex = parseInt(val.substr(0, 8)) % 23;
  if (validChars.charAt(charIndex) === letter) return true;
  return false;
};
/**
 * check nif/nif validation
 */


var calculateNieNif = function calculateNieNif(val, setError, validChars) {
  var lastCharValid = checkLastLetterValidator(val, validChars);
  setError(!lastCharValid);
  return lastCharValid;
};
/**
 * replace  x y z to 0 1 2
 */


var prepareNieVal = function prepareNieVal(searchValue) {
  var nie_prefix = searchValue.charAt(0).toUpperCase();

  switch (nie_prefix) {
    case 'X':
      nie_prefix = 0;
      break;

    case 'Y':
      nie_prefix = 1;
      break;

    case 'Z':
      nie_prefix = 2;
      break;

    default:
      break;
  }

  return nie_prefix + searchValue.substr(1);
};

var nieValidate = function nieValidate(searchValue, setError, validChars) {
  var val = prepareNieVal(searchValue);
  return calculateNieNif(val, setError, validChars);
};

var nifValidate = function nifValidate(searchValue, setError, validChars, selectedItem, setSearchValue, setTextVal) {
  var val = prepareNifVal(searchValue, selectedItem, setSearchValue, setTextVal);
  return calculateNieNif(val, setError, validChars);
};
/* validate tax number according AFM algorithm */


var validateTaxNumber = function validateTaxNumber(searchValue) {
  if (searchValue.length !== 0) {
    if (!searchValue.match(/^\d{9}$/) || searchValue == '000000000') {
      return false;
    }

    var m = 1,
        sum = 0;

    for (var i = 7; i >= 0; i--) {
      m *= 2;
      sum += searchValue.charAt(i) * m;
    }

    return sum % 11 % 10 == searchValue.charAt(8);
  }

  return false;
};

var validationFuncs = {
  validateTaxNumber: validateTaxNumber,
  nieValidate: nieValidate,
  nifValidate: nifValidate
};
exports.validationFuncs = validationFuncs;